/* eslint-disable import/prefer-default-export */
import path from 'path-browserify';

import { ENDPOINT_ROOT } from '@constants/api-constants';

export const getBaseUrl = ({
  version,
}: {
  version: string | number,
}): string => path.join(ENDPOINT_ROOT, `v${String(version)}`);
